// Func = limiting Scope for this file
(function(){

    setTimeout(function(){
        if(document.getElementById('home')){
            document.getElementsByClassName('header__open-table')[0].classList.add('show-object');

        } else {

        }
        document.getElementsByClassName('header__logo-holder')[0].classList.add('show-object');
        document.getElementsByClassName('header__nav-holder')[0].classList.add('show-object');
    }, 500);

	$(document).ready(function () {

        /* animation cleanlines section homepage */
        $('.clean-lines-button').click(function() {
            if($('.clean-lines-section').css("left") == "-420px")
            {
                $(".clean-lines-section").animate({left: '0'});
                $('.clean-lines-button').fadeOut();
                $('.close-cleanlines').fadeIn();
            }
            else
            {
               $(".clean-lines-section").animate({left: '-420px'});
               $('.clean-lines-button').fadeIn();
               $('.close-cleanlines').fadeOut();
            }
        });

        $('.close-cleanlines').click(function() {
            $(".clean-lines-section").animate({left: '-420px'});
            $('.clean-lines-button').fadeIn();
        });

        /* end */
		
	});

}());